var ScrollButton              = require("app/ui/ScrollButton"),
    ScrollerDecoratorCarousel = require("enyo-ui/ScrollerDecoratorCarousel"),
    icons                     = require("app/theme/icons"),
    kind                      = require("enyo/kind");

require("app/ui/ScrollerDecoratorCarousel.less");

module.exports = kind(/** @lends  app.ui.ScrollerDecoratorCarousel.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ScrollerDecoratorCarousel",

    /**
     * @private
     */
    kind: ScrollerDecoratorCarousel,

    /**
     * @private
     */
    classes: "app-ui-scroller-decorator-carousel",

    /**
     * The kind to use for scroll buttons.
     *
     * @type  {enyo.Control}
     * @public
     */
    scrollButtonKind: ScrollButton,

    /**
     * Options for the scroll button used to scroll backward.
     *
     * @type  {?Object}
     * @private
     */
    scrollButtonBackwardOptions: {
        icon: icons["app.ui.ScrollerDecoratorCarousel.scrollButtonBackward"]
    },

    /**
     * Options for the scroll button used to scroll forward.
     *
     * @type  {?Object}
     * @private
     */
    scrollButtonForwardOptions: {
        icon: icons["app.ui.ScrollerDecoratorCarousel.scrollButtonForward"]
    }

});
